import * as React from 'react';
import type { View } from 'react-native';

import type { AnimationCallbacks, AnimationPhases } from './animation';
import { AnimateInternalManagerContext } from './context';

/**
 * Bind a view to a lifecycle animation of the upper AnimateLifeCycle.
 */
export function useAnimateLifecycle(
    phases: AnimationPhases,
    callbacks: AnimationCallbacks = {}
): React.Ref<View> {
    const ref = React.useRef<View>(null);
    const { bindAnimations } = React.useContext(AnimateInternalManagerContext);

    const animatedRef = bindAnimations(ref, phases, callbacks);

    return animatedRef;
}
